export default "__VITE_ASSET__DTtiuwXr__"